import React from 'react';
import logo from '../../assets/brand/chatbizai-logo.png';
import robot from '../../assets/brand/auth-robot.svg';
import './auth.css';

const FEATURES = [
  ['bi-gear-wide-connected', 'Automate Support'],
  ['bi-graph-up-arrow', 'Increase Productivity'],
  ['bi-emoji-smile', 'Delight Your Customers'],
];

/**
 * Split layout shared by every signed-out screen: brand illustration on the left, the form on the right.
 * On phones and small tablets the illustration is hidden and only the form shows.
 */
export default function AuthLayout({ title, subtitle, children, footer }) {
  return (
    <div className="auth-shell">
      <aside className="auth-art" aria-hidden="true">
        <div className="auth-art__inner">
          <img className="auth-art__robot" src={robot} alt="" />
          <h2 className="auth-art__title">Your AI Assistant<span>for a Better Tomorrow</span></h2>
          <ul className="auth-art__features">
            {FEATURES.map(([icon, label]) => (
              <li key={label}><span><i className={`bi ${icon}`} /></span>{label}</li>
            ))}
          </ul>
        </div>
      </aside>

      <main className="auth-pane">
        <div className="auth-form">
          <img className="auth-logo" src={logo} alt="ChatBizzAI - Advanced AI Support Chat Bot" />
          <h1 className="auth-title">{title}</h1>
          {subtitle && <p className="auth-subtitle">{subtitle}</p>}
          {children}
          {footer && <p className="auth-footer">{footer}</p>}
        </div>
      </main>
    </div>
  );
}
